"use client";

import { useEffect } from "react";
import { TaskSelectionIllustration } from "@/components/task/task-selection-illustration";
import { useClearForm } from "@/stores/form-store";
import { useClearCurrentTask } from "@/stores/task-store";

export default function TasksPage() {
  const clearCurrentTask = useClearCurrentTask();
  const clearForm = useClearForm();

  useEffect(() => {
    clearCurrentTask();
    clearForm();
  }, [clearCurrentTask, clearForm]);

  return (
    <section aria-label="Área de trabajo" className="flex h-full min-h-0 flex-col bg-neutral-50/60">
      <header className="flex h-14 shrink-0 items-center border-b border-neutral-200/70 bg-white px-6">
        <h1 className="text-sm font-semibold text-neutral-900">Área de trabajo</h1>
      </header>
      <div className="flex min-h-0 flex-1 items-center justify-center overflow-hidden px-4 py-8">
        <div className="flex w-full flex-col items-center gap-5 text-center">
          <div className="flex h-[180px] w-full items-center justify-center min-[1100px]:h-[240px]">
            <div className="scale-75 min-[1100px]:scale-100">
              <TaskSelectionIllustration />
            </div>
          </div>
          <h2 className="text-xl font-semibold tracking-tight text-neutral-950 min-[1100px]:text-2xl">
            Selecciona una tarea
          </h2>
        </div>
      </div>
    </section>
  );
}
